import { Button, Container, Grid, TextField } from "@mui/material";
import Icon from "@mui/material/Icon";
import * as queryString from "query-string";
import React, { useEffect, useState } from "react";
import MultiSelect from "react-multi-select-component";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    getUserDetailbyID,
    getUserGroupList,
    getUserRoleGroupList,
    updateUserGroupbyId,
    updateUserRoleGroupbyId,
    setupdateUserGroupbyId,
    setupdateUserRoleGroupbyId,
    getCostCenterList,
    getEquipmentReportGroupList,
    getMaintenanceApprovalRights,
    postMaintenanceApprovalRights,
} from "../../store/actions/userActions";
import CustomList from "../../components/List/CustomList";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";

function AddGroupsToUser() {
    const dispatch = useDispatch();
    const res = useSelector(({ user }) => user);
    const history = useHistory();
    let [data, setData] = useState({
        userCode: "",
        userName: "",
        department: "",
        plantName: "",
    });
    let [allUserGroupOptions, setAllUserGroupOptions] = useState([]);
    let [selectedUserGroupOptions, setSelectedUserGroupOptions] = useState([]);
    let [allRoleGroupOptions, setAllRoleGroupOptions] = useState([]);
    let [selectedRoleGroupOptions, setSelectedRoleGroupOptions] = useState([]);
    let [allCostCenterOptions, setAllCostCenterOptions] = useState([]);
    let [selectedCostCenterOptions, setSelectedCostCenterOptions] = useState([]);
    let [allEquipmentReportList, setAllEquipmentReportList] = useState([]);
    let [selectedEquipmentReportList, setSelectedEquipmentReportList] = useState([]);
    let [isSelectLoading, setSelectLoading] = useState([]);
    let [roleFunctionsOfUser, setRoleFunctionsOfUser] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [isBackdropOpen, setBackdrop] = useState(true);
    const { t } = useTranslation("translation");

    useEffect(() => {
        LoadHandler();
    }, []);

    useEffect(() => {
        if (res.userDetail) {
            const groupsOfUser = res.userDetail?.groupsOfUser === undefined ? [] : res.userDetail?.groupsOfUser;
            setSelectedUserGroupOptions(
                groupsOfUser.map((item, index) => ({
                    label: item.groupName,
                    value: item.id,
                    name:item.groupName
                }))
            );

            const roleGroupsOfUser = res.userDetail?.roleGroupsOfUser === undefined ? [] : res.userDetail?.roleGroupsOfUser;
            setSelectedRoleGroupOptions(
                roleGroupsOfUser.map((item, index) => ({
                    label: item.name,
                    value: item.id,
                    name:item.name
                }))
            );

            const roleFunctionsOfUser = res.userDetail?.roleFunctionsOfUser === undefined ? [] : res.userDetail?.roleFunctionsOfUser;
            setRoleFunctionsOfUser(roleFunctionsOfUser.map((item) => item.code));

            const obj = res.userDetail;

            for (let key in obj) {
                setData((state) => ({ ...state, [key]: obj[key] }));
            }

            setBackdrop(false);
            setPageLoaded(true);
            setSelectLoading(false);
            if (res.userDetail?.errorCode === 1) {
                setSelectLoading(false);
            }
        }
        if (res.userGroupList) {
            setAllUserGroupOptions(
                res.userGroupList.map((item, index) => ({
                    label: item.groupName,
                    value: item.id,
                    name:item.groupName
                }))
            );
            setSelectLoading(false);
            // if (res.userGroupList?.errorCode === 1) {
            //     dispatch(showErrorSnackbar(res.userDetail?.message))
            // }
        }
        if (res.userRoleGroupList) {
            if (res.userRoleGroupList?.errorCode === 0) {
                setAllRoleGroupOptions(
                    Object.values(res.userRoleGroupList?.resultObject).map((item, index) => ({
                        label: item.name,
                        value: item.id,
                        name:item.name
                    }))
                );
                setSelectLoading(false);
            }
            // if (res.userRoleGroupList?.errorCode === 1) {
            //     dispatch(showErrorSnackbar(res.userDetail?.message))
            // }
        }
        if (res.userGroupbyId !== undefined) {
            if (res.userGroupbyId?.errorCode === 0) {
                LoadHandler();
            }
            // if (res.userGroupbyId?.errorCode === 1) {
            //     dispatch(showErrorSnackbar(res.userDetail?.message))
            // }
            dispatch(setupdateUserGroupbyId(undefined));
        }
        if (res.userRoleGroupbyID !== undefined) {
            if (res.userRoleGroupbyID?.errorCode === 0) {
                LoadHandler();
            }
            // if (res.userRoleGroupbyID?.errorCode === 1) {
            //     dispatch(showErrorSnackbar(res.userDetail?.message))
            // }
            dispatch(setupdateUserRoleGroupbyId(undefined));
        }
        if (res.costCenters?.resultObject) {
            setAllCostCenterOptions(
                res.costCenters?.resultObject.map((item, index) => ({
                    label: item.name,
                    value: item.id,
                    name:item.name
            
                }))
            );
        }
        if (res.eqReportList?.resultObject) {
            setAllEquipmentReportList(
                res.eqReportList?.resultObject.map((item, index) => ({
                    label: item.name,
                    value: item.id,
                    name:item.name
                }))
            );
        }
        if (res.maintenanceApproval?.resultObject) {
            setSelectedCostCenterOptions(
                res.maintenanceApproval?.resultObject.authorizedCostCenters.map((item, index) => ({
                    label: item.name,
                    value: item.id,
                    name:item.name
                }))
            );
            setSelectedEquipmentReportList(
                res.maintenanceApproval?.resultObject.authorizedEquipmentReportGroups.map((item, index) => ({
                    label: item.name,
                    value: item.id,
                    name:item.name
                }))
            );
        }
    }, [res]);

    useEffect(() => {
        if (res?.isTaskUpdatedUser) {
            LoadHandler();
        }
    }, [res.isTaskUpdatedUser]);

    const LoadHandler = () => {
        setSelectLoading(true);
        setSelectLoading(false);
        dispatch(getUserDetailbyID(queryString.parse(window.location.search).id));
        dispatch(getUserGroupList());
        dispatch(getUserRoleGroupList());
        dispatch(getCostCenterList());
        dispatch(getEquipmentReportGroupList());
        dispatch(getMaintenanceApprovalRights(queryString.parse(window.location.search).id));
    };

    const AddHandler = () => {
        const userGroupData = selectedUserGroupOptions.map((item) => item.value);
        setBackdrop(true);
        dispatch(updateUserGroupbyId({ id: queryString.parse(window.location.search).id, data: userGroupData }));
        const roleGroupData = selectedRoleGroupOptions.map((item) => item.value);
        dispatch(updateUserRoleGroupbyId({ id: queryString.parse(window.location.search).id, data: roleGroupData }));
        const costCenterGroupData = selectedCostCenterOptions.map((item) => item.value);
        const equipmentReportListData = selectedEquipmentReportList.map((item) => item.value);
        let payload = {
            userId: queryString.parse(window.location.search).id,
            data: {
                costCenterIds: costCenterGroupData,
                equipmentReportGroupIds: equipmentReportListData,
            },
        };
        dispatch(postMaintenanceApprovalRights(payload));
    };

    const TurnBack = () => {
        history.goBack();
    };

    //override strings in multiselect
    const stringTR = {
        selectSomeItems: t("SelectSomeItems"),
        allItemsAreSelected: t("AllItemsAreSelected"),
        selectAll: t("SelectAll"),
        search: t("Search"),
    };

    return (
        <Container id="aug_Container" maxWidth="md">
            <h1>{t("UserInformation")}</h1>
            {pageLoaded === true ? (
                <Grid id="aug_Grid" container spacing={3}>
                    <Grid id="aug_Grid_1" item xs={12} sm={6} md={3}>
                        <TextField
                            id="aug_TextField"
                            label={t("UserInformation")}
                            value={data.userName}
                            defaultValue={data.userName}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid id="aug_Grid_2" item xs={12} sm={6} md={3}>
                        <TextField
                            id="aug_TextField_1"
                            label={t("UserRegistry")}
                            value={data.userCode}
                            defaultValue={data.userCode}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid id="aug_Grid_3" item xs={12} sm={6} md={3}>
                        <TextField
                            id="aug_TextField_2"
                            label={t("Department")}
                            value={data.department}
                            defaultValue={data.department}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid id="aug_Grid_4" item xs={12} sm={6} md={3}>
                        <TextField
                            id="aug_TextField_3"
                            label={t("PlantName")}
                            value={data.plantName}
                            defaultValue={data.plantName}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid id="aug_Grid_5" item xs={6} sm={6}>
                        <h4>{t("UserGroups")}</h4>
                        <Autocomplete
                            multiple
                            id="aug_Autocomplete_1"
                            options={allUserGroupOptions}
                            limitTags={5}
                            value={allUserGroupOptions.filter((item) => Object.values(selectedUserGroupOptions).map((item) => {return item.name}).includes(item.name))}
                            disableCloseOnSelect={true}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => <TextField {...params} margin="normal" label={t("UserGroups")} variant="outlined" id="aug_table_TextField_0" />}
                            onChange={(event, newValue) => {
                                setSelectedUserGroupOptions(newValue)
                            }}
                            renderOption={(_props, option) => <li {..._props}>{option.name}</li>}
                            size={"normal"}
                        />
                    </Grid>
                    <Grid id="aug_Grid_6" item xs={6} sm={6}>
                        <pre style={{ marginTop: 25 }}>
                            <CustomList id="aug_cl" dense={true} listItems={selectedUserGroupOptions} name="list1" />
                        </pre>
                    </Grid>
                    <Grid id="aug_Grid_7" item xs={6} sm={6}>
                        <h4>{t("RoleGroups")}</h4>
                        <Autocomplete
                            multiple
                            id="aug_Autocomplete_2"
                            options={allRoleGroupOptions}
                            limitTags={5}
                            value={allRoleGroupOptions.filter((item) => Object.values(selectedRoleGroupOptions).map((item) => {return item.name}).includes(item.name))}
                            disableCloseOnSelect={true}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => <TextField {...params} margin="normal" label={t("RoleGroups")} variant="outlined" id="aug_table_TextField_0" />}
                            onChange={(event, newValue) => {
                                setSelectedRoleGroupOptions(newValue)
                            }}
                            renderOption={(_props, option) => <li {..._props}>{option.name}</li>}
                            size={"normal"}
                        />
                    </Grid>
                    <Grid id="aug_Grid_8" item xs={6} sm={6}>
                        <pre style={{ marginTop: 25 }}>
                            <CustomList id="aug_cl" dense={true} listItems={selectedRoleGroupOptions}  name="list2"/>
                        </pre>
                    </Grid>
                    {roleFunctionsOfUser.includes("System.Admin") || roleFunctionsOfUser.includes("MOST.BusinessAdmin") || roleFunctionsOfUser.includes("MaintApprover") ? (
                        <>
                            <Grid id="aug_Grid_7" item xs={6} sm={6}>
                                <h4>{t("CostCenter")}</h4>
                                <Autocomplete
                                    multiple
                                    id="aug_Autocomplete_3"
                                    options={allCostCenterOptions}
                                    limitTags={5}
                                    value={allCostCenterOptions.filter((item) => Object.values(selectedCostCenterOptions).map((item) => {return item.name}).includes(item.name))}
                                    disableCloseOnSelect={true}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => <TextField {...params} margin="normal" label={t("CostCenter")} variant="outlined" id="aug_table_TextField_0" />}
                                    onChange={(event, newValue) => {
                                        setSelectedCostCenterOptions(newValue)
                                    }}
                                    renderOption={(_props, option) => <li {..._props}>{option.name}</li>}
                                    size={"normal"}
                                />
                            </Grid>
                            <Grid id="aug_Grid_8" item xs={6} sm={6}>
                                <pre style={{ marginTop: 25 }}>
                                    <CustomList id="aug_cl" dense={true} listItems={selectedCostCenterOptions} name="list3"/>
                                </pre>
                            </Grid>
                            <Grid id="aug_Grid_7" item xs={6} sm={6}>
                                <h4>{t("EquipmentReportGroup")}</h4>
                                <Autocomplete
                                    multiple
                                    id="aug_Autocomplete_4"
                                    options={allEquipmentReportList}
                                    limitTags={5}
                                    value={allEquipmentReportList.filter((item) => Object.values(selectedEquipmentReportList).map((item) => {return item.name}).includes(item.name))}
                                    disableCloseOnSelect={true}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => <TextField {...params} margin="normal" label={t("EquipmentReportGroup")} variant="outlined" id="aug_table_TextField_0" />}
                                    onChange={(event, newValue) => {
                                        setSelectedEquipmentReportList(newValue)
                                    }}
                                    renderOption={(_props, option) => <li {..._props}>{option.name}</li>}
                                    size={"normal"}
                                />
                            </Grid>
                            <Grid id="aug_Grid_8" item xs={6} sm={6}>
                                <pre style={{ marginTop: 25 }}>
                                    <CustomList id="aug_cl" dense={true} listItems={selectedEquipmentReportList} name="list4"/>
                                </pre>
                            </Grid>
                        </>
                    ) : null}
                    <Grid id="aug_Grid_9" item xs={6} sm={6} style={{ textAlign: "left" }}>
                        <Button id="aug_Button" onClick={TurnBack} variant="contained" endIcon={<Icon>arrow_back</Icon>} style={{ marginRight: 15 }}>
                            {t("TurnBack")}
                        </Button>
                        <Button id="aug_Button_1" onClick={AddHandler} variant="contained" color="primary" endIcon={<Icon>check</Icon>}>
                            {t("Save")}
                        </Button>
                    </Grid>
                </Grid>
            ) : null}
            <LoadingBackdrop id="aug_lbd" />
        </Container>
    );
}

export default AddGroupsToUser;
